import { useLocation } from "react-router-dom";
import React, { useState, ReactNode, useEffect } from "react";
import { Layout } from "antd";
import Navbar from "../DesignLayout/Header";

const { Content } = Layout;

interface MasterProps {
  children: ReactNode;
}

const Master: React.FC<MasterProps> = ({ children }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [hover, setHover] = useState(false);

  const toggleSidebar = () => setCollapsed(!collapsed);
  const disableHoverEffect = () => setHover(!hover);

  // The shared top navigation bar was removed project-wide. Every page carries
  // its own header (Back + the navigation dropdown + Logout), so the global bar
  // was a duplicate second row of the same controls.
  const shouldHideHeader =
    location.pathname === "/quotes-responses-simple" ||
    location.pathname === "/pending-quote-responses" ||
    location.pathname === "/logs" ||
    location.pathname === "/ate-dashboard";

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout>
        <Layout style={{ backgroundColor: "#f0f4f7" }}>
          {!shouldHideHeader && (
            <Navbar
              collapsed={collapsed}
              toggleSidebar={toggleSidebar}
              disableHoverEffect={disableHoverEffect}
            />
          )}

          <Content>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Master;
